﻿import { registerWidgets } from '../widgets/adapters.js';
import { installBrowserRuntime } from '../widgets/runtime.js';

// All adapters share the single public runtime and its instance lifecycle.
registerWidgets(installBrowserRuntime(window));
